var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyCraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-1808990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.9688 24.4062H24.6094V23H23.2031V21.5938H21.7969V23H20.3906V24.4062H7.03125V25.8125H20.3906V27.2188H24.6094V25.8125H37.9688V24.4062ZM23.2031 25.8125H21.7969V24.4062H23.2031V25.8125Z",
    fill: "#14AA40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.5 10.3438C20.1797 10.3438 18.2812 8.44531 18.2812 6.125C18.2812 3.80469 20.1797 1.90625 22.5 1.90625C24.8203 1.90625 26.7188 3.80469 26.7188 6.125C26.7188 8.44531 24.8203 10.3438 22.5 10.3438ZM22.5 3.3125C20.9531 3.3125 19.6875 4.57812 19.6875 6.125C19.6875 7.67188 20.9531 8.9375 22.5 8.9375C24.0469 8.9375 25.3125 7.67188 25.3125 6.125C25.3125 4.57812 24.0469 3.3125 22.5 3.3125Z",
    fill: "#14AA40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.2344 20.1875H14.7656V15.2656C14.7656 13.2969 16.3125 11.75 18.2813 11.75H26.7188C28.6875 11.75 30.2344 13.2969 30.2344 15.2656V20.1875ZM16.1719 18.7813H28.8281V15.2656C28.8281 14.0703 27.9141 13.1562 26.7188 13.1562H18.2813C17.0859 13.1562 16.1719 14.0703 16.1719 15.2656V18.7813Z",
    fill: "#14AA40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.2031 32.1406C23.2031 32.5289 22.8883 32.8438 22.5 32.8438C22.1117 32.8438 21.7969 32.529 21.7969 32.1406C21.7969 31.7523 22.1117 31.4375 22.5 31.4375C22.8883 31.4375 23.2031 31.7523 23.2031 32.1406Z",
    fill: "#14AA40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M43.5941 35.6563V6.125H28.1254C28.1254 6.61719 28.0551 7.10938 27.9144 7.53125H42.1877V28.625H40.7814V8.9375H27.3519C27.0707 9.5 26.6488 9.92188 26.2269 10.3438H39.3752V28.625H5.62519V10.3438H18.7734C18.3516 9.92188 17.9297 9.5 17.6484 8.9375H4.21894V28.625H2.81269V7.53125H17.0859C16.9453 7.10938 16.875 6.61719 16.875 6.125H1.40625V35.6563H17.5781V39.875H11.9531V44.0938H33.0469V39.875H27.4219V35.6563H43.5941ZM2.81288 30.0312H42.1879V34.25H2.81288V30.0312ZM31.641 42.6875H13.3598V41.2812H31.641V42.6875ZM26.016 39.875H18.9848V35.6563H26.016V39.875Z",
    fill: "#14AA40"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyCraIcon);
export default __webpack_public_path__ + "static/media/MyCRAIcon.8eb6246bc8940d54f5eee85bedf6010c.svg";
export { ForwardRef as ReactComponent };